import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

// Configure store with Redux Toolkit while preserving existing functionality
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      // This ensures large non-serializable data in state or actions don't cause warnings
      serializableCheck: {
        // Ignore specific action types if needed (add actual action types here)
        ignoredActions: [],
        // Ignore specific paths in the state if needed
        ignoredPaths: [],
      },
    }).concat(thunk), // Explicitly adding thunk (though Redux Toolkit includes it by default)
  devTools: process.env.NODE_ENV !== 'production',
});

// Remove TypeScript type annotations from JavaScript file
// These should be in a separate TypeScript file

export default store;